export default "/jy.0a2ec66b-cfcd01.png";